<template>
  <div>
    <dashboard-header :text='$t("title.caption")'/>

    <v-card
        elevation="0"
        class="card-border-10">
      <d-table
          class="pa-10"
          :table-data="items"
          :fields="fields"
          :loading="loading"
          :item-click="onItemTableClick"
          :edit="isEdit ? editItem : null"
          :on-delete="isDelete ? deleteItem : null"
          :add="isCreate ? addItem : null"
          :get-items="getItems"
          :custom-total-rows="totalRows"
          :on-delete-content="onDeleteContent"
          :placeholder="$t('title.searchPlaceholder')"
      />

    </v-card>
  </div>
</template>

<script>
import dTable from "../base/DataTable.vue";
import i18n from "../../lang/i18n";
import {API2} from "../../api";
import DashboardHeader from "../component/DashboardHeader";
import mixin from '../../mixin.js';
import { PERMISSIONS } from "../../config/permissions";

export default {
  components: {DashboardHeader, dTable},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      items: [],
      totalRows: 0,
      optionParams: null,
      // removed static permissions - moved to computed
    };
  },
  computed: {
    // Permission computed properties
    isCreate() {
      return this.hasPermission(PERMISSIONS.TITLE_CREATE);
    },
    isEdit() {
      return this.hasPermission(PERMISSIONS.TITLE_UPDATE);
    },
    isDelete() {
      return this.hasPermission(PERMISSIONS.TITLE_DELETE);
    },
    fields() {
      return [
        {value: "name", text: i18n.t("title.name")},
        {value: "employeeCount", text: i18n.t("title.employeeCount"), sortable: false},
        {value: this.isEdit || this.isDelete ? "actions" : null, sortable: false}
      ].filter(field => field.value !== null);
    },
  },
  mounted() {
    this.onTab();
  },
  methods: {
    onTab() {
      this.getItems(this.optionParams)
    },
    async getItems(optionParams) {
      if (!optionParams) return
      this.optionParams = optionParams
      let res = await this.get(API2.TITLE, optionParams)
      if (res) {
        this.totalRows = res.total
        this.items = res.data.map(value => {
          return {
            data: {...value, idDetail: value.titleId},
            name: value.name,
            employeeCount: value.employeeCount || 0,
            createdAt: this.formatDate(value.createdAt)
          };
        });
      }
    },
    onItemTableClick(item) {
      if (!this.checkPermissionOrShowError(PERMISSIONS.TITLE_VIEW, 'Bạn không có quyền xem chi tiết chức danh')) {
        return;
      }
      this.openTab(1, item)
    },
    addItem() {
      this.openTab(2)
    },
    editItem(item) {
      this.openTab(2, item)
    },
    onDeleteContent() {
      return i18n.t("ui.confirmDataDelTitle")
    },
    async deleteItem(item) {
      let res = await this.delete(API2.TITLE, {path: item.data.titleId})
      if (!res) return
      this.showToast("success", i18n.t("base.notification"), i18n.t("base.deleteSuccessful"))
      await this.getItems(this.optionParams);
    },
  }
}
</script>

<style></style>
